import { __decorate } from "tslib";
import PropTypes from 'prop-types';
import { computed } from 'mobx';
import ViewComponent from '../core/ViewComponent';
import localeContext from '../locale-context/LocaleContext';
export default class DataSetComponent extends ViewComponent {
    get dataSet() {
        return this.observableProps.dataSet;
    }
    get lang() {
        const { lang } = this.observableProps;
        if (lang) {
            return lang;
        }
        const { dataSet } = this;
        if (dataSet && dataSet.lang) {
            return dataSet.lang;
        }
        return localeContext.locale.lang;
    }
    getObservableProps(props, context) {
        const observableProps = super.getObservableProps(props, context);
        if ('dataSet' in props) {
            observableProps.dataSet = props.dataSet;
        }
        return observableProps;
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'dataSet',
        ]);
    }
}
DataSetComponent.propTypes = {
    dataSet: PropTypes.object,
    ...ViewComponent.propTypes,
};
__decorate([
    computed
], DataSetComponent.prototype, "lang", null);
